module.exports = __webpack_public_path__ + "d007d4c478543b3cd8e5253131b064a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/new/images/share.jpg
// module id = 3
// module chunks = 0